
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import About2 from "./components/About2";
import Carousel from "./components/Carousel";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
// import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Brands from "./components/Brands";
import Verticals from "./components/Verticals";
// import FloatingChatbot from "./components/FloatingChatbot";

function App() {
  return (
    
    <>
      <Navbar />
      <Hero />
      <About />
      <Carousel />
      <Services />
      <About2 />
      <Brands />
      <Portfolio />
      <Verticals/>
      {/* <Contact /> */}
      <Footer />
      {/* <FloatingChatbot /> */}
    </>
  );
}

export default App;
